<div class="header p-2">
  <!-- <ng-container *ngIf="module == 'supplier'">
    <nav class="horizontal-nav">
      <ul class="nav-list">
        <li *ngFor="let item of menuItems" class="nav-item">
          <a [routerLink]="item.routerLink" class="nav-link">{{
            item.label
          }}</a>
          <ul *ngIf="item.items" class="dropdown">
            <li *ngFor="let subItem of item.items" class="dropdown-item">
              <a [routerLink]="subItem.routerLink" class="dropdown-link">{{
                subItem.label
              }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </ng-container> -->

  <div class="flex flex-wrap justify-content-between">
    <div class="flex align-items-center flex-order-0">
      <ng-container *ngIf="scope !== 'portal'">
        <a *ngIf="logo && logo !== ''" [routerLink]="['/']" class="mr-2">
          <img
            alt="Welcome to Boma"
            class="logo-block my-0 p-0 inline-flex mr-5"
            src="/assets/layout/images/brand/logo-h-dark-text.svg"
            width="160"
          />
        </a>
      </ng-container>
      <a
        *ngIf="scope === 'portal'"
        (click)="this.handleMenuButtonClick.emit($event)"
        class="p-button-text p-button-plain cursor-pointer mr-2"
        style="color: unset"
        tabindex="0"
      >
        <span class="p-button-icon-only p-button-icon">
          <span class="material-icons-round mi-menu"></span>
        </span>
        <span
          class="p-button-label hidden md:block"
          style="vertical-align: super"
          >Menu</span
        >
      </a>

      <p-dropdown
        [options]="links"
        optionLabel="label"
        [(ngModel)]="selectedLink"
        (onChange)="navigate($event.value.route)"
        class="block md:hidden"
      ></p-dropdown>

      <a
        *ngFor="let link of links"
        [href]="link.route"
        [ngClass]="link.buttonClass"
        class="p-button-text p-button-plain mr-2 align-items-center hidden md:block"
      >
        <span class="p-button-icon-only p-button-icon">
          <span [class]="link.iconClass"></span>
        </span>
        <span class="p-button-label" style="vertical-align: super">{{
          link.label
        }}</span>
      </a>
    </div>

    <div class="flex justify-content-end">
      <div class="flex align-items-center flex-order-2 sm:flex-order-1">
        <ng-container *ngIf="module === 'supplier'">
          <div
            class="mb-2 inline-flex layout-topbar px-0"
            *ngIf="checkedUsername; else loading"
          >
            <p-dropdown
              (onChange)="handleEntityOptionChanged()"
              *ngIf="this.entityOption && entityOptions"
              [(ngModel)]="entityOption"
              [options]="entityOptions"
              optionLabel="label"
              optionValue="value"
              scrollHeight="80vh"
            ></p-dropdown>
          </div>
        </ng-container>
      </div>
      <div class="flex align-items-center flex-order-1 sm:flex-order-2">
        <div
          class="mb-2 inline-flex layout-topbar px-0"
          *ngIf="checkedUsername; else loading"
        >
          <ng-container *ngIf="module === 'website'">
            <button
              *ngIf="entityOption"
              (click)="this.displaySwitchContextDialog = true"
              [label]="
                selectedEntity && selectedLocation
                  ? selectedEntity + ', ' + selectedLocation
                  : 'Loading...'
              "
              class="p-button-text p-button-plain"
              pButton
              pRipple
              type="button"
            ></button>

            <ng-container *ngIf="profile">
              <button
                [routerLink]="['/', 'orders']"
                class="p-button-text p-button-plain"
                icon="material-icons-round mi-local-shipping"
                label="Orders"
                pButton
                pRipple
                type="button"
              ></button>

              <a [routerLink]="['/', 'cart']" href="javascript:void(0)">
                <i
                  [value]="cartButtonLabel"
                  class="pi ml-2 pi-shopping-cart mr-4 text-secondary"
                  pBadge
                  severity="success"
                  style="font-size: 2rem"
                ></i>
              </a>
            </ng-container>
          </ng-container>

          <button
            *ngIf="username; else registrationLinks"
            (click)="menu.toggle($event)"
            class="p-button-text p-button-plain"
            label="{{ username }}"
            pButton
            pRipple
            type="button"
          ></button>
          <p-menu
            #menu
            appendTo="body"
            [model]="loginItems"
            [popup]="true"
          ></p-menu>

          <ng-container *ngIf="module === 'supplier'">
            <a
              href="https://forms.gle/esWg949oifoqA5Bh8"
              target="_blank"
              pButton
              pRipple
              type="button"
              icon="material-icons-round mi-rate-review"
              class="p-button p-button-text icon-fix"
            >
            </a>

            <ul class="topbar-menu">
              <li
                [ngClass]="{
                  'active-menuitem ': appMain?.topBarNotificationMenuActive
                }"
                class="notifications-item"
                notification-messages-list
              ></li>
            </ul>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="module === 'website'">
    <ng-container *ngIf="menuItems.length">
      <p-menubar [model]="menuItems"> </p-menubar>
    </ng-container>
  </ng-container>
</div>

<p-dialog
  [(visible)]="displayUpdateDefaultAccountDialog"
  [closable]="false"
  [modal]="true"
  [style]="{ width: '450px' }"
  header="Welcome to Boma!"
>
  <ng-template pTemplate="content">
    <p>
      Congratulations, you have a brand new personal account. Please select your
      home or default delivery location.
    </p>
    <boma-update-location
      (setPoint)="handleSetLocation($event)"
    ></boma-update-location>
  </ng-template>

  <ng-template pTemplate="footer">
    <button
      (click)="handleUpdateDefault()"
      [disabled]="!entityOption || !locationOption"
      class="p-button-text"
      icon="pi pi-check"
      label="Save"
      pButton
      pRipple
    ></button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="displaySwitchContextDialog"
  [modal]="true"
  header="Change Profile"
>
  <div class="grid formgrid mt-2">
    <div class="field col-12">
      <span class="p-fluid">
        <p-dropdown
          appendTo="body"
          (onChange)="handleEntityOptionChanged()"
          [(ngModel)]="entityOption"
          [options]="entityOptions"
        >
        </p-dropdown>
      </span>
    </div>

    <div class="field col-12">
      <span class="p-fluid">
        <ng-container *ngIf="!locationOptions; else selectLocation">
          Loading...
        </ng-container>
        <ng-template #selectLocation>
          <p-dropdown
            appendTo="body"
            [(ngModel)]="locationOption"
            [options]="locationOptions"
          ></p-dropdown>
        </ng-template>
      </span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end">
      <div class="flex-initial flex align-items-center justify-content-center">
        <p-button
          label="Cancel"
          iconPos="right"
          styleClass="p-button-secondary p-button-text"
          (click)="this.displaySwitchContextDialog = false"
        ></p-button>
      </div>
      <div class="flex-initial flex align-items-center justify-content-center">
        <p-button
          label="Save"
          icon="pi pi-check"
          iconPos="right"
          (click)="handleContextChanged()"
          [disabled]="!entityOption || !locationOption"
        ></p-button>
      </div>
    </div>
  </ng-template>
</p-dialog>
<ng-template #registrationLinks>
  <button
    (click)="emitLogin()"
    class="p-button-success p-button-outlined mr-2"
    icon="pi pi-user"
    label="Sign In"
    pButton
    pRipple
  ></button>
</ng-template>

<ng-template #loading>
  <boma-anim-spinning-loader
    [size]="40"
    style="display: inline-block"
  ></boma-anim-spinning-loader>
</ng-template>
